import { BookingPreparationState, BookingPreparationStates } from 'common/modules/bookings/types';
import {
	BookingState,
	BookingPaymentState,
	BookingStates,
	BookingPaymentStates,
} from 'common/modules/bookings';
import { TFunction } from 'react-i18next';

export const getBookingStateLabel = (bookingState: BookingState, t: TFunction): string => {
	const LABELS: Record<BookingState, string> = {
		PENDING: t('bookingStates.pending', 'Pending'),
		ACTIVE: t('bookingStates.active', 'Active'),
		EXPIRED: t('bookingStates.expired', 'Expired'),
		UPCOMING: t('bookingStates.upcoming', 'Upcoming'),
		COMPLETED: t('bookingStates.completed', 'Completed'),
		CANCELLED: t('bookingStates.canceled', 'Canceled'),
	};
	return LABELS[bookingState] ?? '';
};

export const getBookingPaymentStateLabel = (
	paymentState: BookingPaymentState,
	t: TFunction,
): string => {
	const LABELS: Record<BookingPaymentState, string> = {
		PAID: t('bookingPaymentStates.paid', 'Paid'),
		UNPAID: t('bookingPaymentStates.unPaid', 'Unpaid'),
		REFUNDED: t('bookingPaymentStates.refunded', 'Refunded'),
	};

	return LABELS[paymentState] ?? '';
};

export const getBookingPreparationStateLabel = (
	preparationState: BookingPreparationState,
	t: TFunction,
): string => {
	const LABELS: Record<BookingPreparationState, string> = {
		PREPARED: t('bookingPreparationStates.prepared', 'Prepared'),
		NOT_PREPARED: t('bookingPreparationStates.notPrepared', 'Not prepared'),
	};
	return LABELS[preparationState] ?? '';
};

export const getBookingStateValueOptions = (
	t: TFunction,
): { value: BookingState; label: string }[] => {
	return Object.values(BookingStates).map((state) => ({
		value: state,
		label: getBookingStateLabel(state, t),
	}));
};

export const getBookingPaymentStateValueOptions = (
	t: TFunction,
): {
	value: BookingPaymentState;
	label: string;
}[] => {
	return Object.values(BookingPaymentStates).map((state) => ({
		value: state,
		label: getBookingPaymentStateLabel(state, t),
	}));
};

export const getBookingPreparationStateValueOptions = (
	t: TFunction,
): {
	value: BookingPreparationState;
	label: string;
}[] => {
	return Object.values(BookingPreparationStates).map((state) => ({
		value: state,
		label: getBookingPreparationStateLabel(state, t),
	}));
};
